import React from 'react'
import CloseOutlinedIcon from '@material-ui/icons/CloseOutlined'

function LightboxHeaderClose() {
  return <CloseOutlinedIcon />
}

export default LightboxHeaderClose
